import { el, setAttr } from 'redom';

import application from 'application';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';
import NavigableList from 'generics/components/navigable-list/native';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import {
  toClassName
} from './utilities';

import './index.scss';

class Label {

  constructor() {
    this.el = el('label.font-family-item.navigable-list-item', {
      class: 'ellipsis'
    });
  }

  update(option, index, options, context) {
    this.el.textContent = option.label;

    setAttr(this.el, {
      class: 'font-family-item navigable-list-item ellipsis ' + toClassName(option),
      style: {
        fontFamily: option.key
      }
    });

  }

}

class FontFamilySelector {

  constructor(configuration) {

    this.outsideEventRegistration = null;
    this.fontFamily = configuration.fontFamily;
    this.onChange = configuration.onChange;
    this.onClose = configuration.onClose;

    const entries = NavigableList.toEntries(application.system.getFontFamilies(), 'value', 'name');
    this.valueIndex = findIndexByPropertyValue(entries, 'key', this.fontFamily);
    const selectedEntries = [];

    if (this.valueIndex !== -1) {
      selectedEntries.push(entries[this.valueIndex]);
    }

    this.list = new NavigableList({
      OptionEntry: Label,
      noScroll: true,
      onSelect: (item) => {
        this.onClose();
        this.onChange(item);
      },
      entries,
      selectedEntries
    });

    this.el = el('.font-family-selector-main', [this.list]);

  }

  getFontFamiliesReferences() {

    const fontFamilies = application.system.getFontFamilies();

    const fontFamiliesReferences = {};

    for (let fontFamily of fontFamilies) {

      fontFamiliesReferences[fontFamily.name] = 1;

    }

    return fontFamiliesReferences;

  }

  loadFontFamilies() {

    const fontFamiliesReferences = this.getFontFamiliesReferences();

    return application.externalFontFamiliesManager.activateFontFamilies(fontFamiliesReferences);

  }

  displayFontFamiliesMenu() {

    const element = this.el;
    const anchorElement = element.parentNode;
    const viewportElement = void 0;
    const verticalOffset = 10;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = void 0;

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);
    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  onmount() {

    this.loadFontFamilies();
    this.displayFontFamiliesMenu();

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.onClose);

  }

  onunmount() {

    this.outsideEventRegistration.cancel();

  }

}

export default FontFamilySelector;